import { getCookie, setCookie, updateCookie, text_truncate, getBrowserType, installInpObserver, getTrackingNonce, installTapMoveGuard, shouldIgnoreActivation, normalizeCodePlaceholder } from '../core/utils.js';
// import { setCampaignInfo } from '../components/campaign-info.js';

var code = '',
    ccode = '',
    leads_referrer = document.referrer;

/*
  waba-trigger.js

  Ringkasan:
  Script ini menangani klik pada elemen dengan class `.cta-waba` (CTA WhatsApp/WABA) dengan tujuan:
  1) Loader tampil instan agar UX jelas dan mencegah user klik berkali-kali.
  2) WhatsApp dibuka di TAB BARU (bukan tab yang sama) dengan cara yang paling tahan popup-blocker.
  3) Tracking tersimpan dengan reliabel:
     - Prioritas: simpan ke DB via admin-ajax (lebih stabil dibanding REST wp-json yang kadang 403).
     - Fallback: kirim ke Google Sheets via Apps Script jika DB gagal.
  4) Mengatasi lingkungan legacy:
     - Beberapa template/footer lama masih punya handler klik inline yang melakukan `form.submit()`
       untuk redirect tab yang sama.
     - Ada kemungkinan script global memicu klik sintetis (programmatic click) setelah delay.

  Masalah yang pernah terjadi & mitigasinya di file ini:
  - Loader tidak muncul => ditangani dengan display:flex !important + fallback overlay injection.
  - Double event (pointerup lalu click, dan listener di window + document) => ditangani dengan dedupe.
  - "Double trigger" WABA (tab lama ikut redirect setelah beberapa detik) =>
    ditangani dengan kombinasi:
    a) stopPropagation/stopImmediatePropagation untuk memblok handler legacy klik
    b) guard programmatic submit pada form shortener
    c) blok event sintetis menggunakan `Event.isTrusted === false`

  Catatan cara baca:
  - Bagian "click path" (yang harus cepat) dioptimasi: cache cookie, cache URL object,
    dan menunda kerja berat (network, FormData/JSON) ke idle/after paint.
*/

export function waba() {

  // Prevent double-binding if this function is invoked multiple times.
  if (window.__jurnalWabaBound && window.__jurnalWabaHandlerAttached) return;

  installInpObserver();
  installTapMoveGuard();

  var curr_lang = document.documentElement.getAttribute('lang') ? document.documentElement.getAttribute('lang') : 'id';

  var firstlanding = '';

  if(getCookie('user_journey')) {
    var journey_ = getCookie('user_journey');
    journey_ = journey_.split('|');
    if(journey_.length > 1) {
      firstlanding = journey_[0].replace('J','');
    }
  }

  const LOADING_FALLBACK_ID = 'jurnal-waba-loading-fallback';

  // Cache loading nodes so we don't query the whole DOM on every click.
  // Rebuild only if cache is empty (some templates may inject loader later).
  let _cachedLoadingEls = null;
  const getLoadingEls = () => {
    try {
      if (Array.isArray(_cachedLoadingEls) && _cachedLoadingEls.length) return _cachedLoadingEls;
      const live = document.getElementsByClassName('has-loading');
      _cachedLoadingEls = live && live.length ? Array.from(live) : [];
      return _cachedLoadingEls;
    } catch (e) {
      _cachedLoadingEls = [];
      return _cachedLoadingEls;
    }
  };

  // Some templates still include legacy WABA code that calls
  // `form_waba.submit()` to drive redirects in the current tab.
  // Programmatic `form.submit()` bypasses the `submit` event, so we guard it
  // by temporarily blocking submits for the hidden shortener form right after
  // a WABA click (we handle navigation ourselves via a new tab).
  const ensureFormSubmitGuard = () => {
    // Guard ini membungkus HTMLFormElement.prototype.submit.
    // Kenapa perlu?
    // - `form.submit()` itu programmatic dan TIDAK memicu event `submit`, jadi kita
    //   tidak bisa mengandalkan addEventListener('submit', ...).
    // - Legacy inline script melakukan `form_waba.submit()` setelah user klik `.cta-waba`.
    //   Akibatnya: tab yang sama bisa ikut redirect (bug kritikal).
    // - Solusi: selama window waktu tertentu setelah WABA klik, kita blok submit
    //   untuk form shortener tertentu.
    if (window.__jurnalWabaFormSubmitGuardInstalled) return;
    window.__jurnalWabaFormSubmitGuardInstalled = true;

    try {
      if (!window.HTMLFormElement || !window.HTMLFormElement.prototype) return;
      const originalSubmit = window.HTMLFormElement.prototype.submit;
      if (typeof originalSubmit !== 'function') return;

      // Avoid double-wrapping.
      if (originalSubmit.__jurnalWrapped) return;

      const wrapped = function() {
        try {
          const until = window.__jurnalBlockWabaFormSubmitUntil || 0;
          const now = Date.now();
          if (now < until) {
            const id = this && this.id ? String(this.id) : '';
            const name = this && this.getAttribute ? String(this.getAttribute('name') || '') : '';
            if (id === 'form_shortener_gclid' || name === 'form-shortener-gclid') {
              // Jika masih dalam window block, abaikan submit.
              // Navigasi sudah ditangani oleh handler utama (open new tab).
              return;
            }
          }
        } catch (e) {}
        return originalSubmit.apply(this, arguments);
      };
      wrapped.__jurnalWrapped = true;

      window.HTMLFormElement.prototype.submit = wrapped;
    } catch (e) {
      // no-op
    }
  };

  ensureFormSubmitGuard();

  const setDisplayImportant = (el, value) => {
    // Sama seperti file lain: paksa display dengan !important agar overlay benar-benar tampil.
    try {
      el.style.setProperty('display', value, 'important');
    } catch (e) {
      el.style.display = value;
    }
  };

  const ensureFallbackLoading = () => {
    // Fallback overlay khusus WABA:
    // Dipakai jika halaman tidak menyediakan `.has-loading`.
    // Ini membuat loader tetap tampil bahkan pada template yang minim.
    let el = document.getElementById(LOADING_FALLBACK_ID);
    if (el) return el;

    el = document.createElement('div');
    el.id = LOADING_FALLBACK_ID;
    el.setAttribute('aria-hidden', 'true');
    el.style.cssText = 'position:fixed;z-index:2147483001;top:0;left:0;width:100%;height:100%;background:#000;opacity:0.5;display:none;align-items:center;justify-content:center;';

    const spinner = document.createElement('div');
    spinner.style.cssText = 'width:60px;height:60px;border:6px solid rgba(255,255,255,0.35);border-top-color:#fff;border-radius:50%;animation:jurnalWabaSpin 0.9s linear infinite;';
    el.appendChild(spinner);

    // Inject keyframes once.
    if (!document.getElementById('jurnal-waba-loading-style')) {
      const style = document.createElement('style');
      style.id = 'jurnal-waba-loading-style';
      style.textContent = '@keyframes jurnalWabaSpin{to{transform:rotate(360deg)}}';
      document.head && document.head.appendChild(style);
    }

    (document.body || document.documentElement).appendChild(el);
    return el;
  };

  const showLoading = () => {
    // Prioritas: gunakan loader global jika ada (loader-guard.js)
    // supaya tampilan konsisten antar fitur.
    if (typeof window.__jurnalShowLoading === 'function') {
      window.__jurnalShowLoading();
      return;
    }
    const loadingEls = getLoadingEls();
    if (loadingEls && loadingEls.length) {
      for (let i = 0; i < loadingEls.length; i++) {
        setDisplayImportant(loadingEls[i], 'flex');
      }
      return;
    }
    setDisplayImportant(ensureFallbackLoading(), 'flex');
  };

  const hideLoading = () => {
    if (typeof window.__jurnalHideLoading === 'function') {
      window.__jurnalHideLoading();
      return;
    }
    const loadingEls = getLoadingEls();
    if (loadingEls && loadingEls.length) {
      for (let i = 0; i < loadingEls.length; i++) {
        setDisplayImportant(loadingEls[i], 'none');
      }
    }
    const fallback = document.getElementById(LOADING_FALLBACK_ID);
    if (fallback) setDisplayImportant(fallback, 'none');
  };

  const rafShowLoading = () => requestAnimationFrame(showLoading);
  const rafHideLoading = () => requestAnimationFrame(hideLoading);

  const scheduleSoon = (fn) => setTimeout(fn, 0);
  // Ensure the browser gets at least one paint opportunity before running work.
  // This helps the loader appear immediately after click on slow devices.
  const scheduleAfterPaint = (fn) => {
    // Pola: requestAnimationFrame -> setTimeout 0
    // Tujuan: memberi kesempatan browser melakukan paint 1 frame.
    // Ini penting agar overlay loader terlihat dulu sebelum kita melakukan kerja berat.
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(() => setTimeout(fn, 0));
    } else {
      setTimeout(fn, 0);
    }
  };
  const scheduleIdle = (fn) => {
    // Menunda pekerjaan non-kritis ke waktu idle untuk meningkatkan INP.
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(fn, { timeout: 1500 });
    } else {
      setTimeout(fn, 0);
    }
  };

  const makeClickShort = () => {
    const d = new Date();
    const DD = String(d.getDate()).padStart(2, '0');
    const MM = String(d.getMonth() + 1).padStart(2, '0');
    const YY = String(d.getFullYear()).slice(2);
    const hh = String(d.getHours()).padStart(2, '0');
    const mm = String(d.getMinutes()).padStart(2, '0');
    const ss = String(d.getSeconds());
    const ms = String(d.getMilliseconds());
    return DD + MM + YY + hh + mm + ss + ms;
  };

  const siteDomainConst = window.location.host || '';

  // Ticket code format — configurable from WP Admin (WABA settings), one per
  // language (same "lang_code=value" convention as Message Templates).
  // Use {{code}} as placeholder for the dynamic timestamp portion.
  // Resolved per-click (see clickHandler) once the page language is known.
  const ticketFormats = (window.mlatConfig && window.mlatConfig.waba && window.mlatConfig.waba.ticketFormats) || {};

  const scriptURL = (window.mlatConfig && window.mlatConfig.waba && window.mlatConfig.waba.gsheetsUrl) || 'https://script.google.com/macros/s/AKfycbzpfADklTe8mxAB0mJHYes9Srkz4mHpWpl_JHJPZ6OV6_e63YEwqK2apDlndXFMZPmp/exec';

  const wpApiLink = document.querySelector('link[rel="https://api.w.org/"]');
  const wpJsonBase = (wpApiLink && wpApiLink.href)
    ? wpApiLink.href.replace(/\/?$/, '/')
    : (window.location.origin + '/wp-json/');
  const wpDbURL = wpJsonBase + 'jurnal/v1/waba';
  const wpSiteBase = wpJsonBase.replace(/wp-json\/?$/, '');
  // Prefer the server-baked URL (window.mlatConfig.ajaxUrl) over deriving it from
  // <link rel="https://api.w.org/">: on multilingual sites that link can come back
  // locale-prefixed (e.g. /en/wp-json/), and admin-ajax.php is never under that prefix.
  const wpAjaxURL = (window.mlatConfig && window.mlatConfig.ajaxUrl)
    || (wpSiteBase.replace(/\/?$/, '/') + 'wp-admin/admin-ajax.php');

  // Precompute browser/device once (avoid heavy UA regex on each click).
  const ua = navigator.userAgent || '';
  const ua4 = ua.substr(0, 4);
  const isMobileUA = (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(ua) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-([2-7])|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(ua4));
  const devicetypeConst = isMobileUA ? 'mobile' : 'desktop';
  const browserTypeConst = getBrowserType();

  // Avoid rebuilding URL object on every click.
  // URL object (new URL(...)) relatif mahal jika sering dibuat.
  // Karena click handler bisa sering terpanggil, kita cache berdasarkan href.
  let _cachedHref = '';
  let _cachedUrl = null;
  const getUrlObj = () => {
    const href = window.location.href;
    if (!_cachedUrl || href !== _cachedHref) {
      _cachedHref = href;
      _cachedUrl = new URL(href);
    }
    return _cachedUrl;
  };

  // Hoist regex/constants out of click path.
  // Regex ini dipakai untuk klasifikasi keyword/utm_term.
  // Kita letakkan di luar handler agar tidak dibuat ulang pada setiap klik.
  const _mlatKw = (window.mlatConfig && window.mlatConfig.waba && window.mlatConfig.waba.keywords) || {};
  // Master on/off switch for Keyword Routing Patterns (admin toggle).
  const _mlatKwRoutingEnabled = window.mlatConfig && window.mlatConfig.waba && window.mlatConfig.waba.kwRoutingEnabled;

  // GATE is a reserved label: utm_term must match it before kw classification runs.
  // If no GATE is configured, every utm_term is evaluated.
  // Wrapped in try/catch: patterns come from admin settings and may be invalid regex.
  let _kwGate = null;
  try {
    _kwGate = _mlatKw['GATE']
      ? new RegExp('(' + String(_mlatKw['GATE']).replace(/\s*\|\s*/g, '|') + ')', 'i')
      : null;
  } catch (e) {
    if (window.__jurnalWabaDebug) console.warn('[mlat] GATE pattern invalid:', e.message);
  }

  // Build per-category entries. Format: "Label=include1|include2!excl1|excl2"
  // Patterns after '!' are exclusions: if utm_term also matches one, this label is skipped.
  // Each entry is built in its own try/catch so one bad pattern doesn't drop the whole list.
  let kwEntries = [];
  try {
    kwEntries = Object.keys(_mlatKw)
      .filter(function(label) { return label !== 'GATE'; })
      .reduce(function(acc, label) {
        try {
          var raw = String(_mlatKw[label] || label);
          var excIdx = raw.indexOf('!');
          var includeStr = (excIdx >= 0 ? raw.slice(0, excIdx) : raw).replace(/\s*\|\s*/g, '|');
          var excludeStr = excIdx >= 0 ? raw.slice(excIdx + 1).replace(/\s*\|\s*/g, '|') : '';
          acc.push({
            label: label,
            regex: new RegExp('(' + includeStr + ')', 'i'),
            excludeRegex: excludeStr ? new RegExp('(' + excludeStr + ')', 'i') : null
          });
        } catch (e) {
          if (window.__jurnalWabaDebug) console.warn('[mlat] kw pattern invalid for', label, ':', e.message);
        }
        return acc;
      }, []);
  } catch (e) {
    kwEntries = [];
  }

  // WhatsApp message templates per language (key=template, {kw} placeholder for keyword label).
  const _mlatMsgTpl = (window.mlatConfig && window.mlatConfig.waba && window.mlatConfig.waba.messageTemplates) || {};

  // Dedicated message template for Keyword Routing Patterns matches — separate
  // from _mlatMsgTpl above (which is also used for the plain Default/direct-
  // visitor case). Empty per-language entries fall back to _mlatMsgTpl.
  const _mlatKwMsgTpl = (window.mlatConfig && window.mlatConfig.waba && window.mlatConfig.waba.kwMessageTemplates) || {};

  // Query Keyword Chat Templates — SEPARATE mechanism from Keyword Routing
  // Patterns above, though both read utm_term. This one matches utm_term
  // against two admin-configured keyword lists via simple case-insensitive
  // substring OR-matching (no GATE/category/exclude layers) to pick a
  // distinct WABA message template + ticket marker ({{marker}} token in
  // Ticket Code Format). Anything matching neither list falls through to
  // Ticket Code Format + the global WhatsApp Message Templates field (see
  // _applyDefaultTemplate below), with the default marker.
  const _mlatQkw = (window.mlatConfig && window.mlatConfig.waba && window.mlatConfig.waba.queryKeywords) || {};

  // Exact match (one keyword/phrase per line, case-insensitive, whitespace-
  // trimmed) — NOT substring matching. utm_term must equal one of the list's
  // lines exactly; a short generic entry like "erp" will NOT also match
  // "erp terbaik" or "sap erp" (unlike Keyword Routing Patterns above, which
  // is intentionally left as substring/regex matching — a different,
  // unrelated mechanism this doesn't change).
  const _qkwBuildMatcher = (rawList) => {
    try {
      const parts = String(rawList || '')
        .split(/\r?\n/)
        .map((s) => s.trim().toLowerCase())
        .filter(Boolean);
      if (!parts.length) return null;
      const set = new Set(parts);
      return { test: (term) => set.has(String(term || '').trim().toLowerCase()) };
    } catch (e) {
      return null;
    }
  };
  const _qkwTop20Regex = _qkwBuildMatcher(_mlatQkw.top20Keywords);
  const _qkwEverRegex = _qkwBuildMatcher(_mlatQkw.everKeywords);

  // Detect current page language: WPML → html[lang] → URL prefix → default 'id'.
  const detectPageLang = () => {
    try {
      if (window.wpml_current_language) return String(window.wpml_current_language).toLowerCase();
      const htmlLang = document.documentElement.lang;
      if (htmlLang) return htmlLang.split('-')[0].toLowerCase();
      const m = window.location.pathname.match(/^\/([a-z]{2})\//);
      if (m) return m[1];
    } catch (e) {}
    return 'id';
  };

  // Lazy DOM cache (in case waba() runs before the form is in DOM).
  // Beberapa halaman mungkin merender form hidden belakangan.
  // Kita cache referensi elemen DOM tapi tetap bisa re-query jika belum ada.
  let _domCache = null;
  const getDomCache = () => {
    if (_domCache && (_domCache.formWaba || _domCache.wabaRedirect)) {
      return _domCache;
    }

    const formWaba = document.querySelector('#form_shortener_gclid');
    _domCache = {
      wabaRedirect: document.querySelector('#waba_redirect'),
      formWaba,
      form: document.forms['form-shortener-gclid'] || null,
      fields: formWaba ? {
        f_gclid_short: document.querySelector('#f_gclid_short'),
        f_gclid: document.querySelector('#f_gclid'),
        f_device: document.querySelector('#f_device'),
        f_utmsource: document.querySelector('#f_utmsource'),
        f_utmmedium: document.querySelector('#f_utmmedium'),
        f_utmcampaign: document.querySelector('#f_utmcampaign'),
        f_utmterm: document.querySelector('#f_utmterm'),
        f_banner_id: document.querySelector('#f_banner_id'),
        f_gclid_journey: document.querySelector('#f_gclid_journey'),
        f_matchtype: document.querySelector('#f_matchtype'),
        f_journey: document.querySelector('#f_journey'),
        f_gaid: document.querySelector('#f_gaid'),
        f_waba_medium: document.querySelector('#f_waba_medium'),
        f_browser: document.querySelector('#f_browser'),
        f_referrer: document.querySelector('#f_referrer'),
        f_query_keyword: document.querySelector('#f_query_keyword'),
        f_visitor_id: document.querySelector('#f_visitor_id'),
        f_label: document.querySelector('#f_label'),
      } : null,
    };
    return _domCache;
  };

  const formDataToObject = (fd) => {
    // Konversi FormData menjadi object sederhana.
    // Dipakai untuk membuat payload tracking yang konsisten.
    const obj = {};
    fd.forEach((value, key) => {
      if (obj[key] === undefined) obj[key] = value;
    });
    return obj;
  };

  const buildDbPayload = (data) => {
    // Normalisasi payload yang akan dikirim ke DB.
    // Fungsi pick() mengambil value pertama yang tersedia dari beberapa kandidat key
    // (berguna karena nama field kadang berbeda antar template).
    const pick = (...keys) => {
      for (let i = 0; i < keys.length; i++) {
        const k = keys[i];
        const v = data && data[k] != null ? String(data[k]) : '';
        if (v !== '') return v;
      }
      return '';
    };

    return {
      short: pick('short', 'gclid_short', 'f_gclid_short'),
      gclid: pick('gclid', 'f_gclid'),
      journey: pick('journey', 'f_journey'),
      utm_term: pick('utm_term', 'f_utmterm'),
      matchtype: pick('matchtype', 'f_matchtype'),
      device: pick('device', 'f_device'),
      button_label_id: pick('button_label_id', 'label', 'f_label'),
      gaid: pick('gaid', 'f_gaid'),
      utm_source: pick('utm_source', 'f_utmsource'),
      utm_medium: pick('utm_medium', 'f_utmmedium'),
      utm_campaign: pick('utm_campaign', 'f_utmcampaign'),
      utm_content: pick('utm_content', 'f_utmcontent'),
      campaign_id: pick('campaign_id', 'f_campaignid'),
      banner_id: pick('banner_id', 'f_banner_id'),
      waba_medium: pick('waba_medium', 'f_waba_medium'),
      browser: pick('browser', 'f_browser'),
      domain: pick('domain'),
      gclid_journey: pick('gclid_journey', 'f_gclid_journey'),
      // `referrer` should follow lead_referrer (attribution), empty if none.
      referrer: pick('referrer', 'f_referrer', 'lead_referrer', 'leads_referrer') || getCookie('lead_referrer') || '',
      query_search_term: pick('query_search_term', 'query_keyword', 'f_query_keyword'),
      visitor_id: pick('visitor_id', 'f_visitor_id'),
    };
  };

  const postToDb = async (form) => {
    const fd = new FormData(form);
    const payload = buildDbPayload(formDataToObject(fd));

    const res = await fetch(wpDbURL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
      keepalive: true
    });

    if (!res.ok) {
      throw new Error('DB endpoint HTTP ' + res.status);
    }

    const json = await res.json().catch(() => null);
    if (!json || json.ok !== true) {
      throw new Error('DB endpoint invalid response');
    }

    return json;
  };

  const postToGSheetsFromPayload = (payload) => {
    const fd = new FormData();
    fd.append('Short', payload.short || '');
    fd.append('GCLID', payload.gclid || '');
    fd.append('Journey', payload.journey || '');
    fd.append('UTM Term', payload.utm_term || '');
    fd.append('Matchtype', payload.matchtype || '');
    fd.append('Device', payload.device || '');
    fd.append('Button Label & Button ID', payload.button_label_id || '');
    fd.append('Button Journey', payload.button_label_id || '');
    fd.append('GAID', payload.gaid || '');
    fd.append('utm_source', payload.utm_source || '');
    fd.append('utm_medium', payload.utm_medium || '');
    fd.append('utm_campaign', payload.utm_campaign || '');
    fd.append('utm_content', payload.utm_content || '');
    fd.append('campaign_id', payload.campaign_id || '');
    fd.append('Banner ID', payload.banner_id || '');
    fd.append('Waba Medium', payload.waba_medium || '');
    fd.append('Browser', payload.browser || '');
    fd.append('Domain', payload.domain || window.location.host || '');
    fd.append('GCLID Journey', payload.gclid_journey || '');
    fd.append('Referrer', payload.referrer || siteDomainConst);
    fd.append('Query Search Term', payload.query_search_term || '');
    fd.append('Visitor ID', payload.visitor_id || '');

    return fetch(scriptURL, { method: 'POST', body: fd, keepalive: true });
  };

  const postToDbAjax = async (payload) => {
    // Endpoint DB via admin-ajax.
    // keepalive:true membantu agar request tetap terkirim walau user langsung pindah tab.
    if (window.__jurnalWabaDebug) console.log('[mlat waba] POST →', wpAjaxURL + '?action=mlat_waba_store');
    const res = await fetch(wpAjaxURL + '?action=mlat_waba_store', {
      method: 'POST',
      // text/plain: CORS-safelisted (tidak pernah preflight); PHP baca php://input mentah.
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
      keepalive: true
    });

    const json = await res.text().catch(() => '').then(text => {
      try { return JSON.parse(text); } catch {
        // PHP may prepend notices/warnings — try extracting the JSON object.
        const m = text.match(/(\{[\s\S]*\})/);
        if (m) try { return JSON.parse(m[1]); } catch {}
        if (window.__jurnalWabaDebug) console.warn('[mlat waba] non-JSON response body:', text.substring(0, 300));
        return null;
      }
    });
    if (window.__jurnalWabaDebug) console.log('[mlat waba] response (HTTP ' + res.status + '):', json);
    // HTTP 200 + null JSON: PHP notices corrupted the response body but the request
    // was processed (PHP only returns 200 on success path). Assume DB OK, skip GSheets.
    if (json === null && res.status === 200) {
      if (window.__jurnalWabaDebug) console.warn('[mlat waba] HTTP 200 but unparseable body — assuming DB OK, skipping GSheets');
      return { success: true };
    }
    if (!json || json.success !== true) {
      const msg = (json && json.data && json.data.message) ? json.data.message : ('admin-ajax HTTP ' + res.status);
      const err = new Error(msg);
      // If PHP returned non-200 with unreadable JSON, PHP already called GSheets (DB-fail path).
      err.gsheets_sent = !!(json && json.data && json.data.gsheets_sent) || (json === null && res.status !== 200);
      throw err;
    }

    return json;
  };

  const scheduleSendToDbThenFallback = (payload) => {
    // Tracking dilakukan di waktu idle agar tidak mengganggu respons klik.
    // Urutan:
    // 1) admin-ajax DB
    // 2) jika gagal -> GSheets
    const send = () => {
      // AJAX-only: skip REST (wp-json) to avoid 403 blocks.
      postToDbAjax(payload)
        .then((json) => {
          if (window.__jurnalWabaDebug) console.log('[mlat] DB insert OK', json);
        })
        .catch((errAjax) => {
          if (errAjax && errAjax.gsheets_sent) {
            if (window.__jurnalWabaDebug) console.log('[mlat] GSheets already sent by server, skipping JS fallback');
            return;
          }
          console.error('[mlat] admin-ajax DB post failed, fallback to GSheets:', errAjax && errAjax.message ? errAjax.message : errAjax);
          return postToGSheetsFromPayload(payload)
            .then(response => {
              if (response && response.status == 200) {
                if (window.__jurnalWabaDebug) console.log('[mlat] GSheets fallback OK');
              } else {
                console.error('[mlat] GSheets response code : ', response && response.status ? response.status : 'unknown');
              }
            })
            .catch(err => {
              console.error('[mlat] GSheets error!', err && err.message ? err.message : err);
            });
        });
    };

    // Fire immediately — payload is built before navigation so no need to defer.
    // Using scheduleIdle here would add up to 1500ms delay, risking data loss
    // if the page unloads (mobile deep-link to WhatsApp).
    send();
  };

  // Ensure buttons become visible.
  // Di CSS theme, `.cta-waba` sering dibuat pointer-events:none sampai class `.show` ditambahkan.
  // Ini mencegah klik sebelum script siap.
  // NOTE: beberapa UI (mis. modal tab-grid) inject HTML via innerHTML setelah initial load,
  // jadi kita perlu juga menandai CTA yang muncul belakangan.
  const markWabaButtonsVisible = (root) => {
    try {
      if (!root) return;

      const markOne = (el) => {
        try {
          if (el && el.classList && el.classList.contains('cta-waba')) {
            el.classList.add('show');
          }
        } catch (e) {}
      };

      // Root itself might be the button.
      if (root.nodeType === 1) markOne(root);

      // And/or it may contain buttons.
      if (root.querySelectorAll) {
        root.querySelectorAll('.cta-waba').forEach(markOne);
      }
    } catch (e) {}
  };

  // Expose a manual refresh hook (optional for dynamic UIs).
  // Example usage: window.__jurnalWabaRefreshButtons(modalEl)
  if (typeof window.__jurnalWabaRefreshButtons !== 'function') {
    window.__jurnalWabaRefreshButtons = markWabaButtonsVisible;
  }

  markWabaButtonsVisible(document);

  // Auto-refresh when DOM changes (for dynamically injected content).
  if (!window.__jurnalWabaCtaObserverInstalled && typeof window.MutationObserver === 'function') {
    try {
      const pending = new Set();
      let scheduled = false;

      const flush = () => {
        scheduled = false;
        pending.forEach((node) => markWabaButtonsVisible(node));
        pending.clear();
      };

      const scheduleFlush = () => {
        if (scheduled) return;
        scheduled = true;
        // Use rAF so we run after DOM mutations batch.
        if (typeof window.requestAnimationFrame === 'function') {
          window.requestAnimationFrame(flush);
        } else {
          setTimeout(flush, 0);
        }
      };

      const obs = new MutationObserver((mutations) => {
        for (let i = 0; i < mutations.length; i++) {
          const m = mutations[i];
          if (!m || !m.addedNodes) continue;
          for (let j = 0; j < m.addedNodes.length; j++) {
            const n = m.addedNodes[j];
            if (!n || n.nodeType !== 1) continue;
            // Only keep nodes that could contain .cta-waba to limit work.
            if (
              (n.classList && n.classList.contains('cta-waba')) ||
              (n.querySelector && n.querySelector('.cta-waba'))
            ) {
              pending.add(n);
              scheduleFlush();
            }
          }
        }
      });

      obs.observe(document.documentElement, { childList: true, subtree: true });
      window.__jurnalWabaCtaObserverInstalled = true;
    } catch (e) {
      // no-op
    }
  }

  const getCtaButtonFromEvent = (e) => {
    // Ambil elemen `.cta-waba` dari event:
    // - prioritas: target.closest('.cta-waba')
    // - fallback: e.composedPath() untuk kasus shadow DOM / event retargeting
    const rawTarget = e && e.target;
    const target = (rawTarget && rawTarget.nodeType === 3) ? rawTarget.parentElement : rawTarget;

    if (target && typeof target.closest === 'function') {
      const closest = target.closest('.cta-waba');
      if (closest) return closest;
    }

    if (e && typeof e.composedPath === 'function') {
      const path = e.composedPath();
      for (let i = 0; i < path.length; i++) {
        const node = path[i];
        if (node && node.classList && node.classList.contains('cta-waba')) return node;
      }
    }

    return null;
  };

  const clickHandler = (e) => {
    // Handler utama WABA.
    // Kriteria penting:
    // - Harus cepat (show loader + open tab terjadi saat user gesture)
    // - Harus aman dari double event
    // - Harus memblokir handler legacy yang mencoba redirect tab yang sama
    // Guard against multiple listeners handling the same event.
    if (e && e.__jurnalWabaHandled) return;

    if (window.__jurnalWabaDebug) console.log('WABA CTA clicked');

    const button = getCtaButtonFromEvent(e);
    if (!button) {
      if (window.__jurnalWabaDebug) console.warn('[mlat waba] click: no .cta-waba found in event path, skipped.');
      return;
    }

    if (window.__jurnalWabaDebug) {
      console.log('[mlat waba] button detected:', {
        id: button.id || '(none)',
        classes: button.className,
        href: (button.getAttribute('href') || '').substring(0, 80),
        isTrusted: e && e.isTrusted,
      });
    }

    // Ignore synthetic/programmatic events (e.g. `el.click()` / `dispatchEvent`).
    // Those can re-trigger after a delay and cause popup-blocked fallbacks that
    // redirect the current tab.
    // Kenapa blok event sintetis itu penting?
    // - Ada script lain (global/legacy) yang kadang memanggil `element.click()` atau
    //   `dispatchEvent(new MouseEvent('click'))` setelah beberapa detik.
    // - Event seperti itu `isTrusted === false`.
    // - Jika kita izinkan, ia bisa memicu "fallback" popup-blocker dan akhirnya
    //   melakukan redirect di tab yang sama (bug yang kamu temui).
    try {
      if (e && typeof e.isTrusted === 'boolean' && e.isTrusted === false) {
        // Allow synthetic clicks when test/automation bypass flag is set.
        // Usage from Selenium/BrowserStack:
        //   driver.execute_script("window.__jurnalWabaAllowUntrusted = true;")
        if (window.__jurnalWabaAllowUntrusted === true) {
          // fall through — treat as trusted
        } else {
          try { document.documentElement.dataset.jurnalWabaBlockedSynthetic = String(Date.now()); } catch (err) {}
          try { if (typeof e.preventDefault === 'function') e.preventDefault(); } catch (err) {}
          try { if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation(); } catch (err) {}
          try { if (typeof e.stopPropagation === 'function') e.stopPropagation(); } catch (err) {}
          return;
        }
      }
    } catch (err) {}

    try {
      document.documentElement.dataset.jurnalWabaFired = String(Date.now());
    } catch (err) {}

    if (e) e.__jurnalWabaHandled = true;

    // Block legacy hidden-form submit (same-tab redirect) for a short time.
    // This is intentionally a bit longer than the delayed redirect reported.
    // Window block ini memberi waktu untuk menahan legacy script yang melakukan submit
    // (biasanya terjadi beberapa detik setelah klik).
    try { window.__jurnalBlockWabaFormSubmitUntil = Date.now() + 8000; } catch (err) {}

  // Stop legacy click handlers (some templates still attach inline listeners
  // that submit a form and redirect the current tab after a delay).
  // Kita lakukan preventDefault + stopPropagation di awal untuk memutus rantai handler lain.
  try { if (e && typeof e.preventDefault === 'function') e.preventDefault(); } catch (err) {}
  try { if (e && typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation(); } catch (err) {}
  try { if (e && typeof e.stopPropagation === 'function') e.stopPropagation(); } catch (err) {}

    // Show loader synchronously so it reliably appears even on slow CPU.
    // (Using requestAnimationFrame here can race with setTimeout work and never paint.)
    // Catatan: loader harus dipanggil sinkron (langsung), bukan menunggu raf,
    // karena kalau device berat, user tidak sempat melihat overlay dan akan klik lagi.
    const loadingShownAt = (window.performance && typeof window.performance.now === 'function')
      ? window.performance.now()
      : Date.now();

    showLoading();

    // Open a tab immediately (required to avoid popup blockers). We'll set the final URL right after.
    // Pola popup-blocker:
    // - window.open hanya diizinkan ketika masih dalam user gesture (handler klik).
    // - kita buka about:blank dulu, baru set lokasi setelah paint.
    // Di mobile: WhatsApp App langsung menangkap deep-link di tab yang sama,
    // membuka tab baru malah menimbulkan blank tab yang tersisa.
    const newTab = isMobileUA ? null : window.open('about:blank', '_blank');

    // ── SYNCHRONOUS: compute $url and navigate the new tab ──────────────────
    // Safari iOS revokes the gesture token after any async boundary (rAF/setTimeout).
    // All ops below are fast (string/cookie reads) so they are safe to run
    // synchronously within the user-gesture stack.
    const url = getUrlObj();
    const sp = url.searchParams;

    const cookieCache = new Map();
    const gc = (key) => {
      if (cookieCache.has(key)) return cookieCache.get(key);
      const val = getCookie(key) || '';
      cookieCache.set(key, val);
      return val;
    };

    const browserType = browserTypeConst;
    const click_sh = makeClickShort();
    const _ticketLang = detectPageLang();
    const ticketFormat = normalizeCodePlaceholder(ticketFormats[_ticketLang] || ticketFormats['id'] || ticketFormats['default'] || '[Req.J{{code}}]');
    const gclid = sp.get('gclid') || gc('gclid');
    const msclkid = sp.get('msclkid') || gc('msclkid');
    const umedium = sp.get('utm_medium') || gc('utm_medium');
    const ucampaign = sp.get('utm_campaign') || gc('utm_campaign');
    const usource = sp.get('utm_source') || gc('utm_source');
    const campaignId = sp.get('campaign_id') || gc('campaign_id');
    const utm_term = sp.get('utm_term') || gc('utm_term');
    const matchtype = sp.get('matchtype') || gc('matchtype');
    // query_keyword (query_search_term) is kept for DB/analytics payload
    // tracking further below — it is NOT used to drive Query Keyword Chat
    // Templates matching (see _qsTerm below), only utm_term is.
    const query_keyword = sp.get('query') || gc('query_keyword') || 'null';

    // Decide the ticket marker + optional template override based on the
    // visitor's utm_term (paid ads keyword), BEFORE building ticketStr so
    // {{marker}} resolves correctly regardless of which downstream
    // message-building path runs below. query_search_term (?query=) is
    // intentionally NOT consulted here — Query Keyword Chat Templates
    // matches on utm_term only.
    const _qsTerm = utm_term || '';
    // Default Marker only applies when the visitor DOES carry a utm_term
    // that isn't registered in Top 20/Ever — a truly organic/direct visitor
    // (no utm_term at all) gets NO marker character, not the Default Marker.
    let _qkwMarker = '';
    let _qkwTemplateOverride = null;
    if (_mlatQkw.enabled !== false && _qsTerm) {
      if (_qkwTop20Regex && _qkwTop20Regex.test(_qsTerm)) {
        _qkwMarker = _mlatQkw.top20Marker || '*';
        _qkwTemplateOverride = _mlatQkw.top20Templates || null;
      } else if (_qkwEverRegex && _qkwEverRegex.test(_qsTerm)) {
        _qkwMarker = _mlatQkw.everMarker || '^';
        _qkwTemplateOverride = _mlatQkw.everTemplates || null;
      } else {
        _qkwMarker = _mlatQkw.defaultMarker || '-';
      }
    }
    if (window.__jurnalWabaDebug) {
      console.log('[mlat qkw] keyword dipakai (utm_term):', _qsTerm || '(kosong)', '| marker:', _qkwMarker, '| template override:', _qkwTemplateOverride ? 'yes' : 'no (pakai default)');
    }

    const ticketStr = ticketFormat.replace('{{code}}', click_sh).replace('{{marker}}', _qkwMarker);
    const devicetype = devicetypeConst;
    const banner_journey = gc('banner_journey');
    const cta_journey = gc('cta_journey');
    const cta_last_click = gc('cta_last_click');
    const medium_code = gc('waba_code');

    let gclidmsclkid = '';
    if (gclid || msclkid) {
      gclidmsclkid = text_truncate(gclid + '|' + msclkid, 250, '');
    }

    let $url = button.getAttribute('href') || '';
    // Normalize href coming from various renderers (esc_url / HTML attributes).
    // - `&amp;`           => `&`
    // - `%7B%7Bcode%7D%7D` => `{{code}}`
    // - `<code>`           => `{{code}}`  (alternative placeholder format)
    // - `%3Ccode%3E`       => `{{code}}`  (URL-encoded <code>)
    $url = String($url)
      .replace(/&amp;/g, '&')
      .replace(/%7B%7Bcode%7D%7D/ig, '{{code}}')
      .replace(/%3Ccode%3E/ig, '{{code}}')
      .replace(/<code>/ig, '{{code}}');

    if ($url) {
      // Helper: replace {{code}} placeholder, detecting whether a separator is already present.
      const _replaceCode = (url, code) => {
        const ticket = ticketFormat.replace('{{code}}', code).replace('{{marker}}', _qkwMarker);
        return url.replace('{{code}}', ticket);
      };

      // Opt-in: a button explicitly marked with the "text-waba" class keeps
      // its OWN text (e.g. a promo-specific message baked into that button's
      // own href) instead of being overwritten by the admin-configured
      // template — for every other .cta-waba button (the vast majority,
      // which already carry the plugin's generic default text), behavior is
      // unchanged: the admin-configured template always wins. This has to
      // stay opt-in — most buttons already have non-empty text of their own
      // (the generic default), so if preservation applied globally, the
      // Query Keyword Chat Templates / Keyword Routing Patterns templates
      // configured in wp-admin would basically never take effect.
      const _preserveButtonText = button.classList.contains('text-waba');

      // Old buttons commonly hardcode " - " right after {{code}} as their own
      // separator (from before Ticket Code Format had {{marker}}/%0A). When
      // preserving a button's own text, strip that leading separator — Ticket
      // Code Format already supplies whatever separator/newline it needs, so
      // keeping the button's old one too would just double it up.
      const _stripLeadingSeparator = (text) => text.replace(/^[\s]*-?[\s]*/, '');

      // Helper: inject the resolved ticket string. When _preserveButtonText
      // is true and the button's own href already has text after {{code}}
      // (or in text=), that text wins over the admin-configured template
      // (fallbackTpl: global WhatsApp Message Templates, a qkw Top20/Ever
      // template, or a Keyword Routing Patterns template) — the template is
      // used when the button has no text of its own, or when the button
      // isn't opted in at all. The ticket number + {{marker}} always resolve
      // dynamically either way.
      const _injectTicket = (url, fallbackTpl) => {
        if (url.includes('{{code}}')) {
          const idx = url.indexOf('{{code}}');
          const before = url.slice(0, idx);
          const after = url.slice(idx + '{{code}}'.length);
          const useOwnText = _preserveButtonText && after.trim() !== '';
          return before + ticketStr + (useOwnText ? _stripLeadingSeparator(after) : (fallbackTpl || ''));
        }
        const textMatch = url.match(/text=([^&]*)/i);
        if (textMatch) {
          let existing = '';
          try { existing = decodeURIComponent(textMatch[1] || ''); } catch (e) { existing = textMatch[1] || ''; }
          const useOwnText = _preserveButtonText && existing.trim() !== '';
          const msg = ticketStr + (useOwnText ? _stripLeadingSeparator(existing) : (fallbackTpl || ''));
          return url.replace(/(text=)[^&]*/i, '$1' + encodeURIComponent(msg));
        }
        return _replaceCode(url, click_sh);
      };

      // Helper: build the message from Ticket Code Format + the global WhatsApp
      // Message Templates field (same construction as the qkw/keyword-routing
      // paths below). Used whenever no keyword-based routing applies, so the
      // separator/newline configured in Ticket Code Format (e.g. "%0A") is the
      // only separator used — avoids double separators from the button's own
      // static href text (which pre-dates the {{marker}}/%0A convention).
      const _applyDefaultTemplate = (url) => {
        const _defLang = detectPageLang();
        const _defTpl = (_mlatMsgTpl[_defLang] || _mlatMsgTpl['id'] || '').replace('{kw}', '');
        return _injectTicket(url, _defTpl);
      };

      // Keyword Routing Patterns category label ({kw}) — computed unconditionally
      // (as long as the feature is enabled and utm_term is present) so it's
      // available for {kw} substitution no matter which final template wins.
      // A visitor's utm_term can match BOTH Query Keyword Chat Templates
      // (Top20/Ever) AND a Keyword Routing Patterns category — in that case
      // qkw still wins the template/marker choice, but {kw} still resolves
      // to the matched category if the winning template happens to use the
      // token.
      var kw = '';
      var _passesGate = true;
      if (_mlatKwRoutingEnabled !== false && utm_term !== '') {
        // Layer 1 — GATE: utm_term must pass brand/long-tail filter (if configured).
        _passesGate = !_kwGate || _kwGate.test(utm_term);

        if (window.__jurnalWabaDebug) {
          console.group('[mlat kw] keyword matching');
          console.log('utm_term       :', utm_term);
          console.log('GATE pattern   :', _kwGate ? _kwGate.toString() : '(none — semua utm_term lolos)');
          console.log('passesGate     :', _passesGate);
          console.log('kwEntries      :', kwEntries.map(function(e) { return e.label + ' → ' + e.regex + (e.excludeRegex ? ' EXCL:' + e.excludeRegex : ''); }));
        }

        // Layer 2 — Category: first match wins.
        // Layer 3 — Exclude: skip label if utm_term also matches its '!' exclusion.
        if (_passesGate) {
          for (var _ki = 0; _ki < kwEntries.length; _ki++) {
            var _kwe = kwEntries[_ki];
            var _matched = _kwe.regex.test(utm_term);
            var _excluded = _kwe.excludeRegex && _kwe.excludeRegex.test(utm_term);
            if (window.__jurnalWabaDebug) console.log('  check [' + _kwe.label + '] matched=' + _matched + (_kwe.excludeRegex ? ' excluded=' + _excluded : ''));
            if (_matched) {
              if (!_excluded) {
                kw = "'" + _kwe.label + "' ";
                if (window.__jurnalWabaDebug) console.log('  ✅ label matched:', _kwe.label);
                break;
              } else {
                if (window.__jurnalWabaDebug) console.log('  ⛔ label excluded:', _kwe.label);
              }
            }
          }
          if (window.__jurnalWabaDebug && kw === '') console.log('  (no category matched → kw kosong)');
        }
        if (window.__jurnalWabaDebug) console.groupEnd();
      }

      if (_qkwTemplateOverride) {
        // Query-keyword-based routing matched (Top 20 or Ever) — takes precedence
        // over the utm_term-based Keyword Routing Patterns below, per-design:
        // these are two independent mechanisms and this one is checked first.
        // {kw} (computed above) still applies if the winning template uses it —
        // e.g. a visitor matching both Top 20 and a Keyword Routing Patterns
        // category gets the Top 20 template/marker with {kw} filled in.
        const _qkwLang = detectPageLang();
        const _qkwTplRaw = _qkwTemplateOverride[_qkwLang] || _qkwTemplateOverride['id'] || '';
        const _qkwTpl = _qkwTplRaw.replace(/\{\{utm_term\}\}/g, _qsTerm).replace('{kw}', kw);
        if (window.__jurnalWabaDebug) {
          console.log('[mlat qkw] using query-keyword template, lang:', _qkwLang, '| template:', _qkwTpl || '(kosong)', '| {kw}:', kw || '(kosong)');
        }
        $url = _injectTicket($url, _qkwTpl);
      } else if (_mlatKwRoutingEnabled !== false && utm_term !== '') {
        // Apply configured language template when gate passes (even if kw is empty,
        // matching theme behavior: template fires on gate pass regardless of category match).
        const lang = detectPageLang();
        // Dedicated Keyword Routing Patterns template takes precedence over the
        // global WhatsApp Message Templates field — falls back to it when empty.
        const tpl = _mlatKwMsgTpl[lang] || _mlatKwMsgTpl['id'] || _mlatMsgTpl[lang] || _mlatMsgTpl['id'] || '';

        if (window.__jurnalWabaDebug) {
          console.log('lang           :', lang);
          console.log('template       :', tpl || '(kosong — tidak ada template)');
          console.log('kw result      :', kw || '(kosong)');
          console.log('url has {{code}}:', $url.includes('{{code}}'));
        }

        if (_passesGate && tpl) {
          $url = _injectTicket($url, tpl.replace('{kw}', kw));
          if (window.__jurnalWabaDebug) console.log('final WA URL:', $url.substring(0, 120) + '…');
        } else {
          if (window.__jurnalWabaDebug) {
            if (!_passesGate) console.warn('  ⚠️ utm_term tidak lolos GATE → pakai default (Ticket Code Format + WhatsApp Message Templates)');
            else if (!tpl) console.warn('  ⚠️ template kosong → pakai default (Ticket Code Format + WhatsApp Message Templates)');
          }
          $url = _applyDefaultTemplate($url);
        }
      } else {
        if (window.__jurnalWabaDebug) console.log('[mlat kw] utm_term kosong → pakai default (Ticket Code Format + WhatsApp Message Templates)');
        $url = _applyDefaultTemplate($url);
      }
    }

    if($url.includes('{{suff}}')) {
      $url = $url.replace('{{suff}}', '');
    } else if($url.includes('{{suf}}')) {
      $url = $url.replace('{{suf}}', '');
    } else if($url.includes('{{suff1}}')) {
      $url = $url.replace('{{suff1}}', '');
    } else if($url.includes('{{suff2}}')) {
      $url = $url.replace('{{suff2}}', '');
    } else if($url.includes('{{suff3}}')) {
      $url = $url.replace('{{suff3}}', '');
    }

    $url += "&app_absent=0";

    // ── BUILD PAYLOAD before navigation ──────────────────────────────────────
    // CRITICAL: payload must be built and fetch must be started BEFORE any
    // navigation call. On mobile, wa.me deep-links can trigger page unload,
    // which cancels all deferred callbacks (rAF, setTimeout, requestIdleCallback).
    // keepalive:true only helps if the fetch has already started.
    const payload = {
      nonce: getTrackingNonce(),
      short: click_sh,
      gclid: gclidmsclkid,
      journey: (gc('user_journey') ? text_truncate(gc('user_journey'), 250, '') : ''),
      utm_term: utm_term,
      matchtype: matchtype,
      device: (devicetype == 'desktop') ? 'Desktop' : 'Mobile',
      button_label_id: (() => {
        let label = '';
        if (button.classList.contains('ic-wa')) {
          label = 'ID: ' + (button.id || '') + ', Label: Sticky WABA';
        } else if (button.classList.contains('top-banner-sticky') || button.classList.contains('top-banner-bot')) {
          label = 'ID: ' + (button.id || '') + ', Label: Sticky Banner';
        } else if (button.id) {
          label = 'ID: ' + button.id + ', Label: ' + (button.textContent || '');
        } else {
          label = 'ID: , Label: ' + (button.textContent || '');
        }

        let cta_journey_url = '';
        if (cta_journey) {
          if (cta_last_click) {
            cta_journey_url = (cta_last_click !== (button.id || '')) ? (cta_journey + '|' + label) : cta_journey;
          } else {
            cta_journey_url = label;
          }
        } else {
          cta_journey_url = label;
        }

        // Keep cookie tracking behavior.
        if (cta_journey) {
          updateCookie('cta_journey', cta_journey_url);
        } else {
          setCookie('cta_journey', cta_journey_url, 31);
        }

        if (cta_last_click) {
          updateCookie('cta_last_click', button.id || '');
        } else {
          setCookie('cta_last_click', button.id || '', 31);
        }

        return cta_journey_url;
      })(),
      gaid: (gc('gaid') ? gc('gaid') : (gc('_ga') ? gc('_ga').slice(6) : '')),
      utm_source: (usource === 'chatgpt.com') ? 'website' : usource,
      utm_medium: umedium,
      utm_campaign: ucampaign,
      utm_content: (sp.get('utm_content') || gc('utm_content') || ''),
      campaign_id: campaignId || '',
      banner_id: banner_journey || '',
      waba_medium: medium_code || '',
      browser: browserType,
      domain: window.location.host || '',
      gclid_journey: (gc('gclid_journey') ? gc('gclid_journey') : ''),
      referrer: (gc('lead_referrer') || gc('leads_referrer') || ''),
      query_search_term: query_keyword,
      visitor_id: (gc('visitor_id') || '')
    };

    if (window.__jurnalWabaDebug) {
      console.log('[mlat waba] payload to DB:', {
        short: payload.short,
        nonce: payload.nonce ? payload.nonce.substring(0, 6) + '…' : '⚠️ MISSING',
        button_label_id: payload.button_label_id,
        utm_source: payload.utm_source,
        utm_medium: payload.utm_medium,
        utm_campaign: payload.utm_campaign,
        utm_term: payload.utm_term,
        device: payload.device,
        visitor_id: payload.visitor_id,
        ajaxUrl: wpAjaxURL + '?action=mlat_waba_store',
      });
    }

    // ── DATALAYER PUSH (final $url, after {{code}} resolved) ─────────────────
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event:                'linkClick',
        'gtm.triggers':       '',
        'gtm.element':        button,
        'gtm.elementClasses': button.className || '',
        'gtm.elementId':      button.id || '',
        'gtm.elementText':    (button.textContent || '').replace(/\s+/g, ' ').trim().substring(0, 200),
        'gtm.elementUrl':     $url,
        'Page Hostname':      window.location.hostname,
        'Page Path':          window.location.pathname,
        'Page URL':           window.location.href,
      });
      if (window.__jurnalWabaDebug) {
        console.log('[mlat waba datalayer] linkClick pushed, Click URL:', $url.substring(0, 120));
      }
    } catch (_) {}

    // ── NAVIGATE + TRACKING ───────────────────────────────────────────────────
    // Desktop (newTab exists): current page stays alive → fire-and-forget tracking,
    // then set the already-opened tab URL immediately.
    //
    // Mobile (newTab is null): same-tab navigation MAY unload the page.
    // Wait for tracking to finish first (max 3 s), then navigate.
    // This guarantees data is recorded even when WhatsApp deep-link kills the page.
    if (newTab && typeof newTab.location !== 'undefined') {
      // Desktop path — parallel.
      scheduleSendToDbThenFallback(payload);
      try { newTab.location.href = $url; } catch (e2) {
        window.location.href = $url;
      }

      // DOM cleanup deferred (current page stays alive).
      scheduleAfterPaint(() => {
        const dom = getDomCache();
        if (dom && dom.wabaRedirect) dom.wabaRedirect.value = $url;
        const now = (window.performance && typeof window.performance.now === 'function') ? window.performance.now() : Date.now();
        const remaining = Math.max(0, 3000 - Math.max(0, now - loadingShownAt));
        setTimeout(() => { hideLoading(); }, remaining);
      });

    } else {
      // Mobile path — same-tab navigation may unload the page.
      //
      // Dulu: beacon ke DB + GSheets lalu langsung navigate. Beacon yang return
      // `true` cuma berarti "masuk antrean" — di in-app browser
      // (Instagram/Facebook/TikTok/LINE) antrean itu bisa batal saat halaman
      // pindah, dan setiap klik juga tercatat dobel (DB + GSheets).
      //
      // Sekarang: DB via fetch keepalive yang DITUNGGU; GSheets HANYA kalau DB
      // gagal dan server belum kirim sendiri (gsheets_sent) — juga DITUNGGU.
      // Satu klik = satu baris. Maksimal MOBILE_TRACK_MAX_WAIT_MS, lalu navigate
      // apa pun hasilnya (fetch keepalive lanjut di belakang).
      const MOBILE_TRACK_MAX_WAIT_MS = 3000;

      const navigate = () => {
        window.location.href = $url;
        // Deep-links (wa.me) open an external app without unloading the page —
        // the browser tab stays visible. Hide the loader after a short grace
        // period so the user isn't stuck looking at a spinner.
        setTimeout(() => { try { hideLoading(); } catch (_) {} }, 2500);
      };

      const trackingPromise = postToDbAjax(payload)
        .then(() => {
          if (window.__jurnalWabaDebug) console.log('[mlat waba] mobile DB OK → navigating');
        })
        .catch((errAjax) => {
          if (errAjax && errAjax.gsheets_sent) {
            if (window.__jurnalWabaDebug) console.log('[mlat waba] GSheets already sent by server, skipping JS fallback');
            return;
          }
          console.error('[mlat] DB failed on mobile, fallback to GSheets:', errAjax && errAjax.message ? errAjax.message : errAjax);
          return postToGSheetsFromPayload(payload).catch(() => {});
        });

      let navigated = false;
      const navigateOnce = () => {
        if (navigated) return;
        navigated = true;
        navigate();
      };
      trackingPromise.then(navigateOnce, navigateOnce);
      setTimeout(() => {
        if (!navigated && window.__jurnalWabaDebug) console.warn('[mlat waba] mobile tracking still pending after ' + MOBILE_TRACK_MAX_WAIT_MS + 'ms → navigating anyway (keepalive fetch continues)');
        navigateOnce();
      }, MOBILE_TRACK_MAX_WAIT_MS);
    }
  };

  // Bind on window first (earliest in event path), plus a document fallback.
  // Listen to 'click' + 'pointerup': pointerup masih fire pada tap pertama setelah
  // scroll di mobile (yang click-nya ditelan browser), jadi tombol jalan di tap
  // pertama. shouldIgnoreActivation() menyaring klik kanan & scroll/drag.
  let _lastHandledTs = 0;
  let _lastHandledEl = null;
  const dedupedHandler = (e) => {
    const button = getCtaButtonFromEvent(e);
    if (!button) return;

    // Abaikan klik kanan/tengah, pointer sekunder (multi-touch), dan ekor scroll/drag.
    // Tap diam (termasuk tap-to-stop-scroll di mobile) tetap diproses.
    if (shouldIgnoreActivation(e)) return;

    const now = (window.performance && typeof window.performance.now === 'function')
      ? window.performance.now()
      : Date.now();

    // Dedupe across pointer/touch/click chains.
    if (_lastHandledEl === button && (now - _lastHandledTs) < 900) {
      // Important: when a synthetic click follows touch/pointer, we must still
      // prevent default navigation in the current tab.
      try { if (e) e.__jurnalWabaHandled = true; } catch (err) {}
      try { if (e && typeof e.preventDefault === 'function') e.preventDefault(); } catch (err) {}
      try { if (e && typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation(); } catch (err) {}
      try { if (e && typeof e.stopPropagation === 'function') e.stopPropagation(); } catch (err) {}
      return;
    }
    _lastHandledEl = button;
    _lastHandledTs = now;

    clickHandler(e);
  };

  const bind = (target, type) => {
    try {
      target.addEventListener(type, dedupedHandler, { passive: false, capture: true });
    } catch (e) {}
  };

  ['click', 'pointerup'].forEach((type) => {
    bind(window, type);
    bind(document, type);
  });

  // Mark handler attached only after we actually bind.
  window.__jurnalWabaHandlerAttached = true;
  window.__jurnalWabaBound = true;

  try {
    document.documentElement.dataset.jurnalWabaBound = '1';
  } catch (err) {}

  // untuk memanggil function generate campaign info setelah waba code diperoleh

  // if(is_sr == "false") {
  //   setCampaignInfo();
  // }
}